// extracted by mini-css-extract-plugin
export default {"orderByMsg":"OrderBySelect_orderByMsg__WhbzO"};